<template>
    <div v-if="data !== undefined && data.type !== undefined && data.showName !== undefined && !(data.type === 'checkBox' && data.options.length === 0)" :class="clsArray[data.type][formPatternFlag]">
      <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
        <ejs-checkbox ref='checkAll' v-if="data.type === 'checkbox' || data.type === 'checkArray'" @change="checkAll" :checked="checkAllFlag"></ejs-checkbox>
        <span v-show="getRequired" class="h-red-code">* </span>{{data.showName}}
      </div>
      <div class='h-subscriber-inputLit' v-if="data.showName === ''"></div>
      <template v-if="data.type == 'text'">
        <!--<ejs-textbox :cssClass='clsInput' :placeholder='data.placeholder' :readonly='data.readonly' :name='data.name' :value='params.paramVal' v-model='params.paramVal'/>-->
        <div>
          <input :ref='data.name' :class="['e-control', 'e-textbox', 'e-lib', 'e-input',{ 'readonly-background': data.readonly}]" :maxlength='getMaxLength' :placeholder='data.placeholder' :readonly='data.readonly' :name='data.name' v-model='params.paramVal' @click='clickFunc'/>
        </div>
      </template>
      <template v-if="data.type == 'select'">
        <ejs-dropdownlist :ref="data.name" :cssClass='clsSelect' :fields='fields' :dataSource='data.options' :readonly='data.readonly' :name='data.name' :value='data.value' v-model='params.paramVal' :change='selectChange'/>
      </template>
      <template v-if="data.type == 'password'">
        <!--<ejs-textbox :cssClass='clsInput' type='password' :placeholder='data.placeholder' :readonly='data.readonly' :name='data.name' :value='data.value' v-model='params.paramVal'/>-->
        <input :ref='data.name' :class="['e-control', 'e-textbox', 'e-lib', 'e-input',{ 'readonly-background': data.readonly}]" type='password' :placeholder='data.placeholder' :readonly='data.readonly' :name='data.name' v-model='params.paramVal'/>
      </template>
      <template v-if="data.type == 'checkbox' && data.options !== undefined">
        <div :style="clsCheckbox[this.data.options.length === 1 ? 0 : 1]">
           <ejs-checkbox v-for="option in this.data.options" cssClass="h-subscriber-check h-subscriber-checkBoxCommonStyle" ref='checkIndex' :label='option.showName' :name='data.name' :value='option.value' :checked='checkBoxArr[option.value]'  @change="caculateChecks"/>
        </div>
      </template>
      <template v-if="data.type == 'checkArray' && data.options !== undefined">
        <div>
          <ejs-checkbox v-for="(option, index) in this.data.options" cssClass="h-subscriber-check h-subscriber-checkBoxCommonStyle" ref='checkIndex' :value='option.value' :label='option.showName' :checked='checkBoxArr[index]'  @change="caculateChecksArray"/>
        </div>
      </template>
      <template v-if="data.type == 'radio' && data.options !== undefined">
        <div>
          <ejs-radiobutton v-for="(option) in this.data.options" cssClass="h-subscriber-radioCommonStyle" ref="radioButton" :label='option.showName' :value='option.value' :name='data.name' :checked='data.value === option.value' @change="caculateRadioButton"/>
        </div>
      </template>
    </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: 'parseJson',
  props: [
    'data',
    'checkSize',
    'param',
    'formId',
    'formPattern'
  ],
  data() {
    return {
      formPatternFlag: this.formPattern === undefined ? 0 : this.formPattern,
      fields: { text: 'showName', value: 'value' },
      // bootStrapClass: this.checkSize === 3 ? 'col-sm-4' : 'col-sm-3',
      checkBoxArr: [],
      radioArr: [],
      params: {
        name: this.data === undefined ? '' : this.data.name,
        paramVal: this.data === undefined ? '' : this.data.value,
      },
      checkAllFlag: false,
      checkboxMaxValue: 0,
      clickFunc: () => {},
      clsCheckbox: [
        'border: 1px solid #CED4DA; border-radius: 3px; width: 324px',
        'border: 1px solid #CED4DA; border-radius: 3px;'
      ],
      clsArray: {
        text: [
          'h-subscriber-inputBoxDiv',
          'h-subscriber-inputBoxDivInPartten1',
          'h-subscriber-inputBoxDivInPartten2'
        ],
        select: [
          'h-subscriber-inputBoxDiv',
          'h-subscriber-inputBoxDivInPartten1',
          'h-subscriber-inputBoxDivInPartten2'
        ],
        password: [
          'h-subscriber-inputBoxDiv',
          'h-subscriber-inputBoxDivInPartten1',
          'h-subscriber-inputBoxDivInPartten2'
        ],
        checkbox: [
          'h-subscriber-checkBoxDiv',
          '',
          'h-subscriber-inputBoxDivInPartten2'
        ],
        checkArray: [
          'h-subscriber-checkBoxDiv',
          '',
          'h-subscriber-inputBoxDivInPartten2'
        ],
        radio: [
          'h-subscriber-checkBoxDiv',
          '',
          'h-subscriber-inputBoxDivInPartten2',

        ]
      },
      clsInput: 'h-subscriber-input',
      clsSelect: 'h-subscriber-select',
      validateObj: '',
      options: {
        // customPlacement: function(inputElement, errorElement) {
        //   // inputElement = inputElement.closest('.form-group').querySelector('.error');
        //   // inputElement.parentElement.appendChild(errorElement);
        // },
        rules: {
        },
        validationComplete: function (args) {
          if (args.status === 'success') {
            //
          } else {
            //
          }
        },
      },
    };
  },
  computed: {
    getMaxLength() {
      if (this.data.validate !== undefined && this.data.validate !== null && this.data.readonly !== true && this.data.disabled !== true) {
        let _maxLength = 0;
        if (this.data.validate.maxLength !== undefined) {
          try {
            _maxLength = this.data.validate.maxLength[0];
          } catch (e) { // 适配Excel中没有Tips的情况
            _maxLength = this.data.validate.maxLength;
          }
          return _maxLength;
        } else if (this.data.validate.rangeLength !== undefined) {
          try {
            _maxLength = this.data.validate.rangeLength[0][1];
          } catch (e) { // 适配Excel中没有Tips的情况
            _maxLength = this.data.validate.maxLength[1];
          }
          return _maxLength;
        };
        return 99;
      }
      return 99;
    },
    getRequired() {
      if (this.data === undefined || this.data.validate === undefined || this.data.validate.length === 0) {
        return false;
      }
      if (this.data.validate.required !== undefined && this.data.validate.required[0] === true) {
        return true;
      }
      return false;
    }
  },
  methods: {
    checkAll() {
      switch (this.data.type) {
        case 'checkbox': {
          if (this.checkboxMaxValue === this.params.paramVal) {
            this.$refs.checkIndex.forEach((item) => {
              if (this.checkBoxArr[item.value] === true) {
                item.click();
              }
            });
            this.checkAllFlag = false;
          } else {
            this.$refs.checkIndex.forEach((item) => {
              if (this.checkBoxArr[item.value] === false) {
                item.click();
              }
            });
            this.checkAllFlag = true;
          }
          break;
        }
        case 'checkArray': {
          break;
        }
        default:
      }
    },

    caculateChecks(event) {
      const $this = this;
      $this.checkBoxArr[event.event.target.value] = event.checked;
      $this.params.paramVal = 0;
      $this.checkBoxArr.forEach((element, index) => {
        if (element === true) {
          $this.params.paramVal += Math.pow(2, index);
        }
      });
      if ($this.params.paramVal !== $this.checkboxMaxValue) {
        this.checkAllFlag = false;
      } else {
        this.checkAllFlag = true;
      }
    },

    caculateChecksArray(event) {
      const $this = this;
      $this.checkBoxArr[event.event.target.value] = event.checked;
      $this.params.paramVal = [];
      $this.checkBoxArr.forEach((element, index) => {
        if (element === true) {
          $this.params.paramVal[index] = 1;
        } else if (element === false) {
          $this.params.paramVal[index] = 0;
        }
      });
    },

    caculateRadioButton() {
      this.$refs.radioButton.forEach((item, index) => {
        if (item.ej2Instances.checked === true) {
          this.params.paramVal = this.data.options[index].value;
        }
      });
    },

    selectChange() {
      if (this.data.changeClick === true) {
        if (this.data.options === undefined) return;
        for (const option of this.data.options) {
          if (option.value === this.params.paramVal) {
            this.$parent.$childSelectChange(option.attr);
            break;
          }
        }
      }
    },

    validateComponent() {
      if (this.data === undefined || this.data.validate === undefined || this.data.type === undefined) return true;
      if (this.data.type === 'text' || this.data.type === 'password') {
        return this.validateObj.validate(this.data.name);
      }
      return true;
    },

    bindClickFunc(func) {
      this.clickFunc = func;
    },

    getData() {
      return this.params;
    },

    getName() {
      return this.params.name;
    },

    setData(value) {
      this.params.paramVal = value;
      this.$refs[this.data.name].value = value;
      this.validateComponent();
    },

    setSelectOptions(options) {
      this.data.options = options;
    }
  },
  beforeMount() {
    const $this = this;
    if ($this.data === undefined || $this.data.type === undefined) return;
    const binaryArr = [];
    let length = 0;
    let binaryVal;
    switch ($this.data.type) {
      case 'checkbox': // checkbox 返回值为二进制比特位值
        // checkbox初始化
        if ($this.data.options === undefined) return;
        if ($this.data.value === undefined) {
          $this.data.value = 0;
          $this.params.paramVal = 0;
        }
        length = $this.data.options[$this.data.options.length - 1].value + 1; // 数组长度(从0开始的比特位因此+1)
        for (let i = 0; i < length; i++) {
          $this.checkBoxArr[i] = false;
        }
        binaryVal = $this.data.value.toString(2);
        for (const val of binaryVal) { // 默认值转成二进制数组
          binaryArr.push(val);
        }
        binaryArr.reverse();
        for (const index in binaryArr) {
          if (binaryArr[index] === '1') {
            $this.checkBoxArr[index] = true;
          }
        }
        break;
      case 'checkArray': // checkArray 返回值为数组
        if ($this.data.options === undefined) return;
        $this.params.paramVal = [];
        for (let index = 0; index < $this.data.options.length; index++) { // 防止value未设值情况, memsize默认值
          $this.checkBoxArr.push(false);
          $this.params.paramVal[index] = 0;
        }
        if ($this.data.value === undefined || !($this.data.value instanceof Array)) return;
        $this.data.value.forEach((item, index) => {
          if (item === 1) {
            $this.checkBoxArr[index] = true;
            $this.params.paramVal[index] = 1;
          }
        });
    }
  },
  mounted() {
    if (this.data === undefined) return;
    this.validateObj = new FormValidator('#' + this.formId, this.options);
    if (this.data.type === 'text' || this.data.type === 'password') {
      this.validateObj.addRules(this.data.name, this.data.validate);
    }
    switch (this.data.type) {
      case 'checkbox': {
        this.data.options.forEach((item) => {
          this.checkboxMaxValue += Math.pow(2, item.value);
        });
        if (this.checkboxMaxValue === this.params.paramVal) {
          this.checkAllFlag = true;
        }
        break;
      }
      case 'checkArray': {
        break;
      }
      default:
    }
  },
};
</script>

<style scoped>

</style>
